"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagingReferenceType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ImagingReferenceType_Factory = /** @class */ (function () {
    function ImagingReferenceType_Factory() {
    }
    ImagingReferenceType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            ImagingReferenceTypeId: model.ImagingReferenceTypeId,
            IsDefault: model.IsDefault,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    ImagingReferenceType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            ImagingReferenceTypeId: model.ImagingReferenceTypeId,
            IsDefault: model.IsDefault,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return ImagingReferenceType_Factory;
}());
exports.ImagingReferenceType_Factory = ImagingReferenceType_Factory;
